import { createFileRoute } from '@tanstack/react-router';

import { ROLES } from '~/constants';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { CommunicationRoutePage } from '~/features/whatsapp/components/CommunicationPage/CommunicationRoutePage';

// Matches the exact role set granted CHAT resolvers/commands in the ACL role files (adviser,
// teamLeader, divisionLeader, admin) - same set `Header/index.tsx`'s `hasChatAccess` already
// gates the header Chat button and this page's own nav entry with.
export const Route = createFileRoute('/_app/communication')({
    beforeLoad: ({ location }) => {
        authoriseUser([ROLES.adviser, ROLES.team_leader, ROLES.division_leader, ROLES.admin], location);
        const content = 'ROUTE_TITLE.COMMUNICATION';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    component: () => <CommunicationRoutePage />,
});
